import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useCustomReducer } from '../../../../../base/customHooks'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import Table from '../../../../../components/Table'
import IPButton from '../../../../../components/IPButton'
import { IMEIAuthApi } from '../services/imeiAuthApi'
import { excelToJSONWithDate } from '../../../../../base/utils/dataHelper'
import Swal from 'sweetalert2'
import IPFile from '../../../../../components/IPFile'
import { IUploadIMEIModel } from '../models/model'
import { UploadIMEIApi } from '../services/uploadIMEIApi'
import { DeleteIMEIApi } from '../services/deleteIMEIApi'
import moment from 'moment'

interface INetChannelState {
  imeiBool: boolean
}

function NetChannelContentList(props: BaseComponentWithContextProps) {
  const getInitialState = (): INetChannelState => {
    return {
      imeiBool: false
    }
  }

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<INetChannelState>(intialState)

  const locations = [
    { label: 'NetAnasayfa Banner', value: 1 },
    { label: 'NetAnasayfa Ürünler', value: 2 },
    { label: 'iPhone Ürün Serisi Dökümanları', value: 3 },
    //{ label: 'Görseller', value: 4 },
    //{ label: 'Eğitim  Dokümanları', value: 5 },
  ]

  const tableColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'col1',
      },
      {
        Header: 'Sayfa',
        accessor: 'col2',
      },
      {
        Header: 'İşlemler',
        accessor: 'col3',
      },
    ],
    []
  )

  const tableData = useMemo(
    () =>
      locations.map((item, index) => {
        const data = {
          col1: index + 1,
          col2: locations.find(a => a.value == item.value)?.label,
          col3: (
            <a
              data-action-type='edit'
              role='button'
              style={{ cursor: 'pointer' }}
              data-toggle='tooltip'
              data-original-title='Güncelle'
              onClick={() => updateDppAndMicrosoftPages(item.value)}
            >
              <i className='icon-edit' style={{ fontSize: '1.2rem', color: 'green' }}></i>
            </a>
          ),
        }
        return data
      }),
    [locations]
  )

  const checkIMEIAuth = async () => {
    try {
      const res = await new IMEIAuthApi({}).checkAuth()
      if (res) {
        setState({ imeiBool: res })
      }
    } catch (err: any) {
      console.log(err)
    }
  }

  const uploadFile = async (files: File[]) => {
    const datas: any = await excelToJSONWithDate(files[0])
    setIMEI(datas[0])
    return

  }

  const setIMEI = async (imei) => {
    props.showLoading()
    const data: IUploadIMEIModel[] = imei.map(item => ({
      DealerCode: String(item.BayiKodu),
      IMEI: String(item.IMEI),
      Date: (moment(item.Tarih).format("DD.MM.YYYY"))
    }));

    try {
      const res = await new UploadIMEIApi({}).uploadIMEI(data);
      if (res) {
        Swal.fire({
          icon: 'success',
          title: res,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
      }
      props.hideLoading()
    } catch (err: any) {
      props.hideLoading()
      Swal.fire({
        icon: 'error',
        title: err.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      })
    }
  };


  const deleteIMEI = async () => {
    Swal.fire({
      icon: 'question',
      title: 'Bütün IMEI kayıtlarını silmek istediğinize emin misiniz?',
      showConfirmButton: true,
      allowOutsideClick: false,
      showDenyButton: true,
      confirmButtonText: 'Evet',
      denyButtonText: 'Hayır',
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const res = await new DeleteIMEIApi({}).deleteIMEI()
          if (res) {
            Swal.fire({
              icon: 'success',
              title: res,
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          }
        } catch (err: any) {
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      }
    })
  }

  useEffect(() => {
    checkIMEIAuth()
  }, [])


  const navigate: any = useNavigate()

  const updateDppAndMicrosoftPages = async (location: number) => {
    navigate('/admin/HomeAndSiteOperation/NetChannelContentAdd', {
      state: { pageName: locations.find(a => a.value === location)?.label, pageID: location },
    })
  }

  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <span className='h4 m-0'>NetChannel Sayfası</span>
            {
              state.imeiBool &&
              <div className='d-flex gap-2'>
                <div className='buttonsuz' style={{ marginRight: '10px' }}>
                  <a className='campaignExcelBtn' href='/assetWeb/docs/IMEI Örnek Excel.xlsx' target='_blank'>
                    Örnek Excel
                  </a>
                </div>
                <IPButton
                  type='button'
                  className='btn btn-danger'
                  text={'Tüm IMEI Kayıtlarını Sil'}
                  onClick={() => deleteIMEI()}
                />
                <IPFile
                  id='FileInputDealerCode'
                  multiple={false}
                  handleFiles={e => uploadFile(e)}
                  removeAfterSelect={true}
                  className='campaignFileInput'
                  label="Excel'den Yükle"
                />
              </div>
            }
          </div>
          <div className='card-body'>
            <Table columns={tableColumns} data={tableData} currentPage={0} />
          </div>
        </div>
      </div>
    </div>
  )
}
export default componentWithContext(NetChannelContentList)
